import type { FeatureEvents, TrackEvent, UIEvent } from '../new-analytics-types';
import { Action, ActionSubject, TrackAction, TrackActionSubject } from '../new-analytics-types';

export enum TwgCapabilityScreens {
  userConnectedAppsSettingsTab = 'userConnectedAppsSettingsTab',
}

const screen = {};

const ui = {
  platformCapabilityGlobalSettingsEnableMcp: (): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'platformCapabilityEnableMcp',
      source: TwgCapabilityScreens.userConnectedAppsSettingsTab,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/98485',
  }),
  platformCapabilityGlobalSettingsDisableMcp: (): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'platformCapabilityDisableMcp',
      source: TwgCapabilityScreens.userConnectedAppsSettingsTab,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/98486',
  }),
  platformCapabilityGlobalSettingsEnableMcpConfirm: (): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'platformCapabilityEnableMcpConfirm',
      source: TwgCapabilityScreens.userConnectedAppsSettingsTab,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/98487',
  }),
  platformCapabilityGlobalSettingsDisableMcpConfirm: (): UIEvent => ({
    data: {
      action: Action.Clicked,
      actionSubject: ActionSubject.Button,
      actionSubjectId: 'platformCapabilityDisableMcpConfirm',
      source: TwgCapabilityScreens.userConnectedAppsSettingsTab,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/98488',
  }),
};

const track = {
  platformCapabilityGlobalSettingsUpdateSuccess: (attributes: { status: string }): TrackEvent => ({
    data: {
      action: TrackAction.Succeeded,
      actionSubject: TrackActionSubject.TwgPlatformCapabilityGlobalSetting,
      actionSubjectId: 'platformCapabilityMcpGlobalSettingsUpdate',
      source: TwgCapabilityScreens.userConnectedAppsSettingsTab,
      attributes,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/98490',
  }),
  platformCapabilityGlobalSettingsUpdateFailure: (): TrackEvent => ({
    data: {
      action: TrackAction.Errored,
      actionSubject: TrackActionSubject.TwgPlatformCapabilityGlobalSetting,
      actionSubjectId: 'platformCapabilityMcpGlobalSettingsUpdate',
      source: TwgCapabilityScreens.userConnectedAppsSettingsTab,
    },
    dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/98491',
  }),
};

const operational = {};

export const twgCapabilityEvents: FeatureEvents<keyof typeof screen, keyof typeof ui, keyof typeof track, keyof typeof operational> = {
  confluenceSpec: 'https://hello.atlassian.net/wiki/spaces/TEAMGRAPH/pages/6600131689/Platform+MCP+Server+-+M2+analytics+spec',
  screen,
  ui,
  track,
  operational,
};
